import styled from "styled-components";
import { IFlex } from "../types/Interfaces";
import { Div } from "./Overrides";

export const Flex = styled(Div)`
  display: flex;
  flex-direction: ${(props: IFlex) => (props.flexDirection ? props.flexDirection : "row")};
  justify-content: ${(props: IFlex) => (props.justifyContent ? props.justifyContent : "inherit")};
  align-items: ${(props: IFlex) => (props.alignItems ? props.alignItems : "inherit")};
  align-self: ${(props: IFlex) => (props.alignSelf ? props.alignSelf : "inherit")};
  gap: ${(props) => (props.gap ? props.gap : "0")};
  * {
    flex-grow: ${(props) => (props.grow ? 1 : 0)};
  }

  * .p-dropdown-label {
    width: 100% !important;
  }
  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.responsiveReorder ? "column" : "row")};
  }
`;
export const Column = styled(Flex)`
  flex-direction: column;
  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.responsiveReorder ? "row" : "column")};
  }
`;

export const Row = styled(Flex)`
  flex-direction: row;
  align-items: ${(props: IFlex) => (props.alignItems ? props.alignItems : "center")};
  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.responsiveReorder ? "column" : "row")};
  }
`;

export const RowWrap = styled(Row)`
  flex-wrap: wrap;
`;
